import React, { ReactNode } from "react";

import { AddableModuleType } from "@formant/core/model/AddableModuleType";
import { Icon } from "@formant/ui/component/common/Icon";

import { StreamIcon } from "../common/StreamIcon";

interface IModuleStreamIconProps {
    type?: AddableModuleType;
    icon?: ReactNode;
}

export const ModuleStreamIcon = (props: IModuleStreamIconProps) => {
    const { type, icon } = props;
    if (icon) {
        return <>{icon}</>;
    } else if (type === "custom") {
        return <Icon name="utility" />;
    } else if (type === "analytics") {
        return <Icon name="utility" />;
    } else if (type) {
        return <StreamIcon type={type} />;
    }
    return null;
};
